export default __webpack_public_path__ + "static/media/no_data_found.970b8ced.png";